import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store/index';
// import { getObjFromLS } from '@/common/index';
import {
  ENTRY_ENDPOINT_NAME,
  RECEPTIONIST_ENDPOINT_NAME,
  LANDING_ENDPOINT_NAME,
  LANG_CODE_VIETNAMESE,
  LANG_CODE_JAPANESE
} from '@/common/constants';
import { Trans } from '@/plugins/translation.js';

Vue.use(VueRouter);

import LandingPage from '../containers/landingPage/LandingPage.vue';

import Homepage from '../containers/entry/Homepage/Homepage.vue';
import CompanyPage from '../containers/entry/Company/CompanyPage.vue';
import CompanyPreviewPage from '../containers/entry/Company/CompanyPreviewPage.vue';
import ListCompany from '../containers/entry/ListCompany/ListCompany.vue';
import CompanyCode from '../containers/entry/CompanyCode/CompanyCode.vue';
import CompanyQRScan from '../containers/entry/CompanyCode/CompanyQRScan.vue';
import CompanyOptionScan from '../containers/entry/CompanyCode/CompanyOptionScan.vue';
import CompanyCodeScan from '../containers/entry/CompanyCode/CompanyCodeScan.vue';
import CompanyCheckInSuccess from '../containers/entry/CompanyCode/CompanyCheckInSuccess.vue';

import EventSchedulePreview from '../containers/entry/EventSchedule/EventSchedulePreview.vue';
import EventSchedule from '../containers/entry/EventSchedule/EventSchedule.vue';
import MailBox from '../containers/entry/MailBox/MailBox.vue';
import Applications from '../containers/entry/Applications/Applications.vue';
import Profile from '../containers/entry/Profile/Profile.vue';
import Entrance from '../containers/entry/Entrance/Entrance.vue';
import Survey from '../containers/entry/Survey/Survey.vue';
import QRCode from '../containers/entry/QRCode/QRCode.vue';
import Login from '../containers/entry/Auth/Login/Login.vue';

import Register from '../containers/entry/Auth/Register/Register.vue';
import RegisterSuccess from '../containers/entry/Auth/Register/RegisterSuccess.vue';
import ConfirmSuccess from '../containers/entry/Auth/Register/ConfirmSuccess.vue';
import MasterLayout from '../Layout/Master.vue';
import AuthLayout from '../Layout/Auth.vue';
import DefaultLayout from '../Layout/Default.vue';
import ErrorLayout from '../Layout/Error.vue';

import MaterLayoutReceptionist from '../Layout/receptionist/Master';
import AuthLayoutReceptionist from '../Layout/receptionist/Auth';
import DefaultLayoutReceptionist from '../Layout/receptionist/Default';

import LoginReceptionist from '../containers/receptionist/Login/Login.vue';
import HomePageReceptionist from '../containers/receptionist/HomePage/HomePage.vue';
import CodeScanReceptionist from '../containers/receptionist/CodeScan/CodeScan.vue';
import QrScanReceptionist from '../containers/receptionist/QrScan/QrScan.vue';
import ReceptionistStatus from '../containers/receptionist/ReceptionistStatus/ReceptionistStatus.vue';
import ScanSuccess from '../containers/receptionist/ScanSuccess/ScanSuccess.vue';

import LayoutPreviewListCompany from '@/Layout/LayoutPreviewListCompany.vue';

const landingEndPoint = '/information';
const entryEndPoint = '/entry/:contractID/:eventID';
const receptionistEndPoint = '/receptionist/:contractID/:eventID';

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: landingEndPoint + '/:contractID/:eventID',
      name: 'landing-page',
      component: LandingPage,
      meta: {
        requireAuth: false,
        endPointName: LANDING_ENDPOINT_NAME
      }
    },
    {
      path: entryEndPoint,
      component: MasterLayout,
      name: 'master-layout',
      meta: { requireAuth: false },
      children: [
        {
          path: '',
          name: 'auth-master',
          meta: { layout: 'auth', requireAuth: false },
          component: AuthLayout,
          children: [
            {
              path: '/',
              name: 'login-applicant',
              component: Login,
              props: (route) => ({ query: route.query.q }),
              meta: {
                requireAuth: false,
                endPointName: ENTRY_ENDPOINT_NAME
              }
            },

            {
              path: 'register',
              name: 'register-applicant',
              component: Register,
              props: (route) => ({ query: route.query.q }),
              meta: {
                requireAuth: false,
                endPointName: ENTRY_ENDPOINT_NAME
              }
            },

            {
              path: 'register-success',
              component: RegisterSuccess,
              meta: {
                requireAuth: false,
                endPointName: ENTRY_ENDPOINT_NAME
              }
            },

            {
              path: 'company',
              name: 'company-preview',
              component: CompanyPreviewPage,
              meta: {
                publicAndPrivate: true,
                requireAuth: false,
                endPointName: ENTRY_ENDPOINT_NAME
              }
            },
            {
              path: 'confirm/:token',
              name: 'confirm-mail',
              component: ConfirmSuccess,
              meta: {
                requireAuth: false,
                endPointName: ENTRY_ENDPOINT_NAME
              }
            }
          ]
        },

        {
          path: entryEndPoint + '/me',
          name: 'default-layout',
          component: DefaultLayout,
          redirect: entryEndPoint + '/me/top',
          meta: {
            requireAuth: true,
            endPointName: ENTRY_ENDPOINT_NAME
          },
          children: [
            {
              path: entryEndPoint + '/me/top',
              name: 'top-applicant',
              component: Homepage,
              meta: {
                requireAuth: true,
                endPointName: ENTRY_ENDPOINT_NAME
              }
            },

            {
              path: entryEndPoint + '/me/event-schedule',
              name: 'event-schedule',
              component: EventSchedule,
              meta: {
                requireAuth: true,
                endPointName: ENTRY_ENDPOINT_NAME
              }
            },

            {
              path: entryEndPoint + '/me/list-company/:companyID/detail',
              name: 'company-detail',
              component: CompanyPage,
              meta: {
                publicAndPrivate: true,
                requireAuth: true,
                endPointName: ENTRY_ENDPOINT_NAME
              }
            },

            {
              path: entryEndPoint + '/me/list-company',
              name: 'list-company',
              component: ListCompany,
              props: (route) => ({
                query: route.query.q
              }),
              meta: {
                requireAuth: true,
                endPointName: ENTRY_ENDPOINT_NAME
              }
            },
            {
              path: entryEndPoint + '/me/event-schedule',
              name: 'event-schedule',
              component: EventSchedule,
              meta: {
                requireAuth: true,
                endPointName: ENTRY_ENDPOINT_NAME
              }
            },
            {
              path: entryEndPoint + '/me/mail-box',
              name: 'mail-box',
              component: MailBox,
              meta: {
                requireAuth: true,
                endPointName: ENTRY_ENDPOINT_NAME
              }
            },
            {
              path: entryEndPoint + '/me/applications',
              name: 'applications',
              component: Applications,
              meta: {
                requireAuth: true,
                endPointName: ENTRY_ENDPOINT_NAME
              }
            },
            {
              path: entryEndPoint + '/me/profile',
              name: 'profile',
              component: Profile,
              meta: {
                requireAuth: true,
                endPointName: ENTRY_ENDPOINT_NAME
              }
            },
            {
              path: entryEndPoint + '/me/entrance',
              name: 'entrance',
              component: Entrance,
              meta: {
                requireAuth: true,
                endPointName: ENTRY_ENDPOINT_NAME
              }
            },
            {
              path: entryEndPoint + '/me/my-code',
              name: 'my-code',
              component: QRCode,
              meta: {
                requireAuth: true,
                endPointName: ENTRY_ENDPOINT_NAME
              }
            },
            {
              path: entryEndPoint + '/me/survey',
              name: 'survey',
              component: Survey,
              meta: {
                requireAuth: true,
                endPointName: ENTRY_ENDPOINT_NAME
              }
            },
            {
              path: entryEndPoint + '/me/company-code',
              name: 'company-code',
              component: CompanyCode,
              meta: {
                requireAuth: true,
                endPointName: ENTRY_ENDPOINT_NAME
              },
              children: [
                {
                  path: entryEndPoint + '/me/company-code',
                  name: 'company-optionscan',
                  component: CompanyOptionScan,
                  meta: {
                    requireAuth: true,
                    endPointName: ENTRY_ENDPOINT_NAME
                  }
                },
                {
                  path: entryEndPoint + '/me/company-code/qr-scan',
                  name: 'company-qrscan',
                  component: CompanyQRScan,
                  meta: {
                    requireAuth: true,
                    endPointName: ENTRY_ENDPOINT_NAME
                  }
                },
                {
                  path: entryEndPoint + '/me/company-code/code-scan',
                  name: 'company-codescan',
                  component: CompanyCodeScan,
                  meta: {
                    requireAuth: true,
                    endPointName: ENTRY_ENDPOINT_NAME
                  }
                },
                {
                  path: entryEndPoint + '/me/company-code/checkin-success',
                  name: 'company-checkin-success',
                  component: CompanyCheckInSuccess,
                  meta: {
                    requireAuth: true,
                    endPointName: ENTRY_ENDPOINT_NAME
                  }
                }
              ]
            }
          ]
        }
      ]
    },

    {
      path: entryEndPoint + '/list-company-preview',
      component: LayoutPreviewListCompany,
      name: 'list-company-preview',
      meta: {
        publicAndPrivate: true,
        requireAuth: false,
        endPointName: ENTRY_ENDPOINT_NAME
      }
    },
    {
      path: entryEndPoint + '/event-schedule-preview',
      component: EventSchedulePreview,
      name: 'event-schedule-preview',
      meta: { publicAndPrivate: true, requireAuth: false }
    },
    {
      path: receptionistEndPoint,
      name: 'receptionist-login',
      component: MaterLayoutReceptionist,
      meta: { requireAuth: false },

      children: [
        {
          path: '',
          name: 'auth-master-receptionist',
          meta: {
            layout: 'auth',
            requireAuth: false,
            endPointName: RECEPTIONIST_ENDPOINT_NAME
          },
          component: AuthLayoutReceptionist,

          children: [
            {
              path: '/',
              name: 'receptionist-login',
              component: LoginReceptionist,
              props: (route) => ({ query: route.query.q }),
              meta: {
                requireAuth: false,
                endPointName: RECEPTIONIST_ENDPOINT_NAME
              }
            }
          ]
        },

        {
          path: receptionistEndPoint + '/me',
          name: 'default-layout',
          component: DefaultLayoutReceptionist,
          redirect: receptionistEndPoint + '/me/top',
          meta: {
            requireAuth: true,
            endPointName: RECEPTIONIST_ENDPOINT_NAME
          },
          children: [
            {
              path: receptionistEndPoint + '/me/top',
              name: 'top',
              component: HomePageReceptionist,
              meta: {
                requireAuth: true,
                endPointName: RECEPTIONIST_ENDPOINT_NAME
              }
            },

            {
              path: receptionistEndPoint + '/me/code-scan',
              name: 'code-scan',
              component: CodeScanReceptionist,
              meta: {
                requireAuth: true,
                endPointName: RECEPTIONIST_ENDPOINT_NAME
              }
            },

            {
              path: receptionistEndPoint + '/me/qr-scan',
              name: 'qr-scan',
              component: QrScanReceptionist,
              meta: {
                requireAuth: true,
                endPointName: RECEPTIONIST_ENDPOINT_NAME
              }
            },

            {
              path: receptionistEndPoint + '/me/receptionist-status',
              name: 'receptionist-status',
              component: ReceptionistStatus,
              meta: {
                requireAuth: true,
                endPointName: RECEPTIONIST_ENDPOINT_NAME
              }
            },

            {
              path: receptionistEndPoint + '/me/scan-success',
              name: 'scan-success',
              component: ScanSuccess,
              meta: {
                requireAuth: true,
                endPointName: RECEPTIONIST_ENDPOINT_NAME
              }
            }
          ]
        }
      ]
    },
    {
      path: '/page-not-found',
      name: 'page-not-pound',
      component: ErrorLayout
    }
  ]
});

const checkLangFromRouter = (from) => {
  const { query } = from;
  if (
    query.lang &&
    (query.lang == LANG_CODE_VIETNAMESE || query.lang == LANG_CODE_JAPANESE)
  ) {
    store.dispatch('changeLanguage', { lang: query.lang });

    Trans.changeLanguage(query.lang);
  }
};

const checkRouteApplicantLogin = async (
  from,
  next,
  endPoint,
  tokenName,
  eventID,
  contractID
) => {
  const { success } = store.state.checkEvent;
  const { isAuthenticated } = store.state.checkAuth;

  let tokenData = null;
  const nameKeyLS = contractID + eventID;

  const objFromLS =
    localStorage.getItem(nameKeyLS) !== null
      ? JSON.parse(localStorage.getItem(nameKeyLS))
      : null;

  if (typeof objFromLS !== 'undefined' && objFromLS !== null) {
    const { token } = objFromLS;

    const data = {
      event_code: eventID,
      contract_id: contractID
    };

    const fullPath = location.pathname;

    await store.dispatch('getEventMaster', {
      data,
      fullPath
    });

    tokenData = token || null;

    await store.dispatch('setContractAndEvent', { contractID, eventID });
    if (tokenData !== null) {
      await store.dispatch('me');
    }
  }
  await checkLangFromRouter(from);

  if (
    tokenData !== null &&
    from.matched.some((record) => record.meta.requireAuth) === false &&
    success &&
    isAuthenticated
  ) {
    if (from.matched.some((record) => record.meta.publicAndPrivate === true)) {
      next();
    } else {
      const fullPath = endPoint + '/' + contractID + '/' + eventID + '/me';

      next(fullPath);
    }
  } else {
    if (
      tokenData == null &&
      from.matched.some((record) => record.meta.requireAuth)
    ) {
      next(endPoint + '/' + contractID + '/' + eventID);
    }
    next();
  }
};

const checkRouteReceptionistLogin = async (
  from,
  next,
  endPoint,
  tokenName,
  eventID,
  contractID
) => {
  const { isAuthenticated } = store.state.checkAuthReceptionist;

  let tokenData = null;
  const nameKeyLS = contractID + eventID;

  const objFromLS =
    localStorage.getItem(nameKeyLS) !== null
      ? JSON.parse(localStorage.getItem(nameKeyLS))
      : null;

  if (typeof objFromLS !== 'undefined' && objFromLS !== null) {
    const { token_rc } = objFromLS;

    tokenData = token_rc;
    await store.dispatch('setContractAndEvent', { contractID, eventID });
    if (tokenData !== null) {
      await store.dispatch('setTokenStatusForReceptionist');
    }
  }

  await checkLangFromRouter(from);

  if (
    tokenData !== null &&
    from.matched.some((record) => record.meta.requireAuth) === false &&
    isAuthenticated
  ) {
    if (from.matched.some((record) => record.meta.publicAndPrivate === true)) {
      next();
    } else {
      const fullPath = endPoint + '/' + contractID + '/' + eventID + '/me';

      next(fullPath);
    }
  } else {
    if (
      tokenData == null &&
      from.matched.some((record) => record.meta.requireAuth)
    ) {
      next(endPoint + '/' + contractID + '/' + eventID);
    }
    next();
  }
};

router.beforeEach(async (from, to, next) => {
  const { eventID, contractID } = from.params;
  await store.dispatch('setContractAndEvent', { contractID, eventID });
  if (from.matched.length > 0) {
    if (typeof eventID !== 'undefined' && typeof contractID !== 'undefined') {
      const fullPath = from.fullPath;

      if (fullPath.includes('/entry')) {
        checkRouteApplicantLogin(
          from,
          next,
          '/entry',
          'token',
          eventID,
          contractID
        );
      }

      if (fullPath.includes('receptionist')) {
        checkRouteReceptionistLogin(
          from,
          next,
          '/receptionist',
          'token_rc',
          eventID,
          contractID
        );
      }

      if (fullPath.includes('information')) {
        console.log('--check information--');
        await checkLangFromRouter(from);
      }
    }
  } else {
    next();
  }
  next();
});

export default router;
